import { Flatfile } from "@flatfile/api";

export const membersTableConfig: Flatfile.SheetConfig = {
  name: "Member info",
  slug: "membersInfo",
  fields: [
    {
      key: "firstName",
      type: "string",
      label: "First Name",
      constraints: [
        {
          type: "required",
        },
      ],
      alternativeNames: ["Client name"],
    },
    {
      key: "lastName",
      type: "string",
      label: "Last Name",
      constraints: [{ type: "required" }],
    },
    {
      key: "email",
      type: "string",
      label: "Email",
      constraints: [{ type: "unique" }],
    },
    {
      key: "phoneNumber",
      type: "string",
      label: "Phone number",
    },
    {
      key: "memberSince",
      type: "date",
      label: "Member since",
      description: "Please provide a valid date YYYY-MM-DD",
    },
    {
      key: "historicalCheckins",
      type: "string",
      label: "Historical checkins",
    },
    {
      key: "parentAccount",
      label: "Sub-account of...",
      type: "reference",
      config: {
        ref: "membersInfo",
        key: "email",
        relationship: "has-one",
      },
    },
    {
      key: "dob",
      type: "date",
      label: "Date of birth",
      description: "Please provide a valid date YYYY-MM-DD",
    },
    {
      key: "gender",
      label: "Gender",
      type: "enum",
      config: {
        options: [
          {
            value: "M",
            label: "Male",
            alternativeNames: ["Male"],
          },
          {
            value: "F",
            label: "Female",
            alternativeNames: ["Female"],
          },
          {
            value: "",
            label: "Not specified",
            alternativeNames: ["Non binary"],
          },
        ],
      },
    },
    {
      key: "addressLineOne",
      type: "string",
      label: "Address Line One",
      description: "45 characters or fewer",
    },
    {
      key: "addressLineTwo",
      type: "string",
      label: "Address Line Two",
    },
    {
      key: "city",
      type: "string",
      label: "City",
    },
    {
      key: "stateOrProvince",
      type: "string",
      label: "State or Province",
      description: "Please abbreviate (e.g. AZ for Arizona)",
    },
    {
      key: "postalCode",
      type: "string",
      label: "Postal code",
    },
  ],
};
